import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useSectionNav } from "../lib/lenisStore";

const LINKS = [
  { label: "The Archive", id: "gallery", testid: "nav-archive-link" },
  { label: "Manifesto", id: "manifesto", testid: "nav-manifesto-link" },
  { label: "Collections", id: "packages", testid: "nav-collections-link" },
  { label: "Voices", id: "testimonials", testid: "nav-voices-link" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const scrollToSection = useSectionNav();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-40 border-b backdrop-blur-xl transition-colors duration-500 ${
        scrolled ? "bg-surface/80 border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => scrollToSection("hero")}
          className="font-serif text-lg tracking-wide text-ivory"
        >
          ÉV <span className="text-gold">&</span> CM
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={link.testid}
              onClick={() => scrollToSection(link.id)}
              className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-400 hover:text-champagne transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <Link
            to="/journal"
            data-testid="nav-journal-link"
            className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-400 hover:text-champagne transition-colors duration-300"
          >
            Journal
          </Link>
        </nav>
        <div className="flex items-center gap-5">
          <span
            data-testid="nav-availability-badge"
            className="hidden lg:inline-flex items-center gap-2 text-[10px] font-mono tracking-[0.2em] uppercase text-stone-400"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-gold animate-pulse" />
            Accepting 2026/27
          </span>
          <button
            data-testid="nav-inquire-cta"
            onClick={() => scrollToSection("contact")}
            className="hidden sm:block border border-champagne/40 px-5 py-2 text-[11px] font-mono tracking-[0.2em] uppercase text-champagne hover:bg-champagne hover:text-obsidian transition-colors duration-300"
          >
            Reserve a Date
          </button>
        </div>
      </div>
    </motion.header>
  );
}
